import { useFlags } from "launchdarkly-react-client-sdk";
import { useAppSelector } from "../redux/hooks";
import {
    defectCodeChipsSelector,
    regimeDescriptionsSelector
} from "../features/inspectionsSlice";

/**
 * The defect code chips and their tooltips to show, or nothing while
 * releaseAuthorityMappings is off. The mappings themselves are fetched either
 * way, since a Pre-PSC filters its defects on them; this flag only decides
 * whether the codes are shown.
 */
export const useDefectCodeChips = () => {
    const { releaseAuthorityMappings } = useFlags();
    const defectCodes = useAppSelector(defectCodeChipsSelector);
    const descriptions = useAppSelector(regimeDescriptionsSelector);

    if (!releaseAuthorityMappings) {
        return { defectCodes: undefined, descriptions: undefined };
    }

    return { defectCodes, descriptions };
};
